type undefinedArray = undefined[];

export const fakeGameRoundsData = {
  roundDates: [
    { id: 5792816, startDateTime: "2024-05-30T11:48:17Z" },
    { id: 5792830, startDateTime: "2024-05-30T11:48:17Z" },
    { id: 5792842, startDateTime: "2024-05-30T11:48:17Z" },
  ],
  rounds: [
    {
      id: 5792816,
      startDateTime: "2024-05-30T11:48:17Z",
      startPlayerBalance: {
        creditsBalance: { amount: 999999961782, currency: "EUR" },
      },
      precedingGameContext: {
        contextNumber: 0,
        contextData: {
          baseGameResult: {
            reels: [
              [3, 1, 7],
              [1, 5, 2],
              [3, 4, 1],
              [1, 5, 7],
              [3, 2, 6],
            ],
            expandedReels: [false, false, false, false, false],
            winCombinations: [] as undefinedArray,
          },
          stake: { amount: 100, currency: "EUR" },
          win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
          gameRoundBalance: {
            credits: { amount: 0, currency: "EUR" },
            bonusSpins: 0,
          },
          gambleHistory: [3, 3, 3, 3, 1],
          bonus: false,
          finished: true,
          usedInputAction: "BET",
          allowedInputActions: ["BET", "BUY_BONUS"],
        },
      },
      gameContexts: [
        {
          contextNumber: 1,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: {
              credits: { amount: 200, currency: "EUR" },
              bonusSpins: 10,
            },
            gameRoundBalance: {
              credits: { amount: 200, currency: "EUR" },
              bonusSpins: 10,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BET",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 2,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [9, 4, 1],
                [5, 4, 3],
                [3, 5, 4],
                [3, 10, 2],
                [3, 5, 4],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 200, currency: "EUR" },
              bonusSpins: 9,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 3,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [3, 2, 1],
                [5, 7, 8],
                [2, 1, 6],
                [5, 9, 2],
                [2, 7, 6],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 200, currency: "EUR" },
              bonusSpins: 8,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["EXPAND"],
          },
        },
        {
          contextNumber: 4,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [3, 2, 1],
                [5, 7, 8],
                [6, 6, 6],
                [5, 9, 2],
                [6, 6, 6],
              ],
              expandedReels: [false, false, true, false, true],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 1,
                  scatterPositions: [] as undefinedArray,
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 2,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 3,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 4,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 5,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 6,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 7,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 8,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 9,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 10,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 500, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 700, currency: "EUR" },
              bonusSpins: 8,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "EXPAND",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 5,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [2, 1, 10],
                [2, 1, 8],
                [2, 5, 1],
                [5, 10, 4],
                [4, 8, 5],
              ],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 2,
                  count: 3,
                  lineNumber: 2,
                  scatterPositions: [] as undefinedArray,
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 8,
                  count: 2,
                  lineNumber: 3,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 8,
                  count: 2,
                  lineNumber: 7,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 150, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 850, currency: "EUR" },
              bonusSpins: 7,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 6,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [5, 4, 3],
                [4, 7, 1],
                [3, 2, 1],
                [3, 2, 6],
                [5, 4, 7],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 850, currency: "EUR" },
              bonusSpins: 6,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 7,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [1, 10, 7],
                [5, 7, 8],
                [9, 3, 2],
                [2, 6, 1],
                [3, 2, 1],
              ],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 7,
                  count: 2,
                  lineNumber: 1,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 7,
                  count: 2,
                  lineNumber: 5,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 8,
                  count: 2,
                  lineNumber: 8,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 7,
                  count: 2,
                  lineNumber: 10,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 200, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 1050, currency: "EUR" },
              bonusSpins: 5,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 8,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [6, 4, 3],
                [2, 5, 1],
                [4, 6, 2],
                [3, 2, 8],
                [7, 1, 9],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 1050, currency: "EUR" },
              bonusSpins: 4,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["EXPAND"],
          },
        },
        {
          contextNumber: 9,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [6, 6, 6],
                [2, 5, 1],
                [6, 6, 6],
                [3, 2, 8],
                [7, 1, 9],
              ],
              expandedReels: [true, false, true, false, false],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 1,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 2,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 3,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 4,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 5,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 6,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 7,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 8,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 9,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 10,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 500, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 1550, currency: "EUR" },
              bonusSpins: 4,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "EXPAND",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 10,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [5, 6, 3],
                [3, 7, 1],
                [3, 5, 4],
                [7, 5, 4],
                [4, 3, 7],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 1550, currency: "EUR" },
              bonusSpins: 3,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 11,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [6, 4, 3],
                [4, 10, 1],
                [1, 6, 5],
                [7, 8, 3],
                [1, 9, 10],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 1550, currency: "EUR" },
              bonusSpins: 2,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["EXPAND"],
          },
        },
        {
          contextNumber: 12,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [6, 6, 6],
                [4, 10, 1],
                [6, 6, 6],
                [7, 8, 3],
                [1, 9, 10],
              ],
              expandedReels: [true, false, true, false, false],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 1,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 2,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 3,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 4,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 5,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 6,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 7,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 8,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 9,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
                {
                  combinationType: "LINE",
                  symbol: 6,
                  count: 2,
                  lineNumber: 10,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 500, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 2050, currency: "EUR" },
              bonusSpins: 2,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "EXPAND",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 13,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [4, 3, 2],
                [2, 5, 4],
                [2, 1, 7],
                [1, 4, 3],
                [8, 5, 10],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 2050, currency: "EUR" },
              bonusSpins: 1,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: true,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: false,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BONUS_SPIN"],
          },
        },
        {
          contextNumber: 14,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 2, 9],
                [4, 1, 8],
                [3, 7, 10],
                [3, 6, 10],
                [2, 10, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "SCATTER",
                  symbol: 10,
                  count: 3,
                  scatterPositions: [
                    { x: 2, y: 2 },
                    { x: 3, y: 2 },
                    { x: 4, y: 1 },
                  ],
                  win: {
                    credits: { amount: 200, currency: "EUR" },
                    bonusSpins: 10,
                  },
                },
              ],
            },
            bonusGameResult: {
              reels: [
                [2, 5, 1],
                [7, 1, 2],
                [4, 3, 2],
                [2, 6, 1],
                [9, 10, 5],
              ],
              winCombinations: [],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 2050, currency: "EUR" },
              bonusSpins: 0,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: false,
            bonusTriggerType: "BOUGHT",
            expandingSymbol: 6,
            finished: true,
            usedInputAction: "BONUS_SPIN",
            allowedInputActions: ["BET", "BUY_BONUS"],
          },
        },
      ],
    },
    {
      id: 5792930,
      startDateTime: "2024-05-30T12:19:55Z",
      startPlayerBalance: {
        creditsBalance: { amount: 999999953832, currency: "EUR" },
      },
      precedingGameContext: {
        contextNumber: 0,
        contextData: {
          baseGameResult: {
            reels: [
              [3, 2, 9],
              [4, 1, 8],
              [3, 7, 10],
              [3, 6, 10],
              [2, 10, 9],
            ],
            expandedReels: [false, false, false, false, false],
            winCombinations: [
              {
                combinationType: "SCATTER",
                symbol: 10,
                count: 3,
                scatterPositions: [
                  { x: 2, y: 2 },
                  { x: 3, y: 2 },
                  { x: 4, y: 1 },
                ],
                win: {
                  credits: { amount: 200, currency: "EUR" },
                  bonusSpins: 10,
                },
              },
            ],
          },
          bonusGameResult: {
            reels: [
              [2, 5, 1],
              [7, 1, 2],
              [4, 3, 2],
              [2, 6, 1],
              [9, 10, 5],
            ],
            winCombinations: [] as undefinedArray,
          },
          stake: { amount: 100, currency: "EUR" },
          win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
          gameRoundBalance: {
            credits: { amount: 2050, currency: "EUR" },
            bonusSpins: 0,
          },
          gambleHistory: [3, 3, 3, 3, 1],
          bonus: false,
          bonusTriggerType: "BOUGHT",
          expandingSymbol: 6,
          finished: true,
          usedInputAction: "BONUS_SPIN",
          allowedInputActions: ["BET", "BUY_BONUS"],
        },
      },
      gameContexts: [
        {
          contextNumber: 1,
          contextData: {
            baseGameResult: {
              reels: [
                [3, 7, 2],
                [2, 1, 5],
                [9, 2, 4],
                [7, 1, 9],
                [1, 8, 9],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [] as undefinedArray,
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 0, currency: "EUR" },
              bonusSpins: 0,
            },
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: false,
            finished: true,
            usedInputAction: "BET",
            allowedInputActions: ["BET", "BUY_BONUS"],
          },
        },
      ],
    },
    {
      id: 5792942,
      startDateTime: "2024-05-30T12:29:55Z",
      startPlayerBalance: {
        creditsBalance: { amount: 999999953432, currency: "EUR" },
      },
      precedingGameContext: {
        contextNumber: 0,
        contextData: {
          baseGameResult: {
            reels: [
              [1, 7, 4],
              [5, 2, 6],
              [9, 7, 6],
              [7, 8, 6],
              [1, 6, 7],
            ],
            expandedReels: [false, false, false, false, false],
            winCombinations: [] as undefinedArray,
          },
          stake: { amount: 100, currency: "EUR" },
          win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
          gameRoundBalance: {
            credits: { amount: 0, currency: "EUR" },
            bonusSpins: 0,
          },
          gambleHistory: [3, 3, 3, 3, 1],
          bonus: false,
          finished: true,
          usedInputAction: "BET",
          allowedInputActions: ["BET", "BUY_BONUS"],
        },
      },
      gameContexts: [
        {
          contextNumber: 1,
          contextData: {
            baseGameResult: {
              reels: [
                [4, 8, 2],
                [3, 8, 4],
                [3, 7, 2],
                [6, 5, 7],
                [9, 5, 4],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 8,
                  count: 2,
                  lineNumber: 1,
                  scatterPositions: [] as undefinedArray,
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 50, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 50, currency: "EUR" },
              bonusSpins: 0,
            },
            gamblesLeft: 5,
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: false,
            finished: false,
            usedInputAction: "BET",
            allowedInputActions: ["COLLECT", "GAMBLE"],
          },
        },
        {
          contextNumber: 2,
          contextData: {
            baseGameResult: {
              reels: [
                [4, 8, 2],
                [3, 8, 4],
                [3, 7, 2],
                [6, 5, 7],
                [9, 5, 4],
              ],
              expandedReels: [false, false, false, false, false],
              winCombinations: [
                {
                  combinationType: "LINE",
                  symbol: 8,
                  count: 2,
                  lineNumber: 1,
                  scatterPositions: [],
                  win: {
                    credits: { amount: 50, currency: "EUR" },
                    bonusSpins: 0,
                  },
                },
              ],
            },
            stake: { amount: 100, currency: "EUR" },
            win: { credits: { amount: 50, currency: "EUR" }, bonusSpins: 0 },
            gameRoundBalance: {
              credits: { amount: 50, currency: "EUR" },
              bonusSpins: 0,
            },
            gamblesLeft: 5,
            gambleHistory: [3, 3, 3, 3, 1],
            bonus: false,
            finished: true,
            usedInputAction: "COLLECT",
            allowedInputActions: ["BET", "BUY_BONUS"],
          },
        },
      ],
    },
  ],
};

export function getFalseRoundDate() {
  return fakeGameRoundsData.roundDates;
}

export function getAllFakeGameRounds() {
  return fakeGameRoundsData.rounds;
}
